/*       */
import { combineReducers } from 'redux';

import subscriptions from './subscriptions/chatSubscriptionsReducer';
import channel from './channel/chatChannelReducer';
import socket from './socket/chatSocketReducer';
import files from './files/chatFilesReducer';
import user from './user/chatUserReducer';
import room from './room/chatRoomReducer';
import thread from './thread/chatThreadReducer';
import emojis from './emojis/chatEmojisReducer';
import receipts from './receipts/chatReceiptsReducer';

export default combineReducers({
    subscriptions,
    channel,
    socket,
    files,
    room,
    thread,
    user,
    emojis,
    receipts,
});
